import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  const token =
    userProfileSession &&
    (userProfileSession["access_token"] || userProfileSession["token"]);
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const session = getLoggedinUser();
    const t =
      session && (session["access_token"] || session["token"]);
    setUserProfile(session ? session : null);
    setLoading(t ? false : true);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
